import dynamicImport from 'components/dynamicImport';
import { observer, inject } from 'mobx-react';
import React, { Component } from 'react';
import Default from './SellerInviteSection';
import SellerInviteStore from './stores';

const Content = dynamicImport({
  component: '/containers/Sale/SellerInviteSection',
  fallback: Default,
});

@inject('app', 'sale')
@observer
class SellerInviteSection extends Component {
  constructor(props) {
    super(props);
    this.seller = new SellerInviteStore(props.sale);
  }

  render() {
    if (!this.seller.data) {
      return null;
    }
    return <Content {...this.props} seller={this.seller} />;
  }
}

export default SellerInviteSection;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SellerInviteSection/index.jsx